import { render, staticRenderFns } from "./botaoVoltar.vue?vue&type=template&id=692209a8&"
import script from "./botaoVoltar.vue?vue&type=script&lang=js&"
export * from "./botaoVoltar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports